export type FiscalizeInvoicePayload = {
  invoiceId: string;
  folioId: string;
  totalAmount: number;
  currency: "EUR" | "USD" | "PLN";
};

export type FiscalizeInvoiceResult = {
  provider: string;
  reference: string;
};

export interface FiscalIntegrationProvider {
  fiscalizeInvoice(payload: FiscalizeInvoicePayload): Promise<FiscalizeInvoiceResult>;
}

export class InMemoryFiscalIntegrationProvider implements FiscalIntegrationProvider {
  readonly provider = "in-memory-fiscal";
  readonly fiscalizedPayloads: FiscalizeInvoicePayload[] = [];

  async fiscalizeInvoice(payload: FiscalizeInvoicePayload): Promise<FiscalizeInvoiceResult> {
    this.fiscalizedPayloads.push(payload);
    return {
      provider: this.provider,
      reference: `fiscal-${this.fiscalizedPayloads.length.toString().padStart(4, "0")}`,
    };
  }
}
